import OpsHeader from "@/components/opsiq/OpsHeader";
import Seo from "@/components/Seo";
import OpsHero from "@/components/opsiq/OpsHero";
import OpsDataInsight from "@/components/opsiq/OpsDataInsight";
import OpsQuestions from "@/components/opsiq/OpsQuestions";
import OpsWhatWeDo from "@/components/opsiq/OpsWhatWeDo";
import OpsCustom from "@/components/opsiq/OpsCustom";
import OpsCustomers from "@/components/opsiq/OpsCustomers";
import OpsMethodology from "@/components/opsiq/OpsMethodology";
import OpsIndustriesCards from "@/components/opsiq/OpsIndustriesCards";
import OpsWhyChoose from "@/components/opsiq/OpsWhyChoose";
import OpsPromise from "@/components/opsiq/OpsPromise";
import OpsFinalCTA from "@/components/opsiq/OpsFinalCTA";
import OpsFooter from "@/components/opsiq/OpsFooter";
import ScrollProgress from "@/components/opsiq/ScrollProgress";

export default function OpsIQ() {
  return (
    <div data-testid="opsiq-site" className="min-h-screen bg-[#1A2E4A] text-[#F1ECE0] font-plex ops-select">
      <Seo
        title="OpsIQ | Operational Intelligence & Dashboards for Ghana Businesses"
        description="OpsIQ helps organizations improve visibility through custom dashboards, KPI frameworks, and performance management solutions, so leaders can make clear, informed business decisions."
        path="/"
        image="/og-image.jpg?v=2"
        imageAlt="OpsIQ — Ghanaian executive team reviewing an operational dashboard"
      />
      <ScrollProgress />
      <OpsHeader />
      <main>
        <OpsHero />
        <OpsDataInsight />
        <OpsQuestions />
        <OpsWhatWeDo />
        <OpsCustom />
        <OpsMethodology />
        <OpsIndustriesCards />
        <OpsWhyChoose />
        <OpsCustomers />
        <OpsPromise />
        <OpsFinalCTA />
      </main>
      <OpsFooter />
    </div>
  );
}
